<template>
  <el-table-column
    prop="company.tax_number"
    label="Adószám"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.company.tax_number }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'company.tax_number',
  };
</script>
